import { render, staticRenderFns } from "./Certified.vue?vue&type=template&id=4811b5f8&"
import script from "./Certified.vue?vue&type=script&lang=js&"
export * from "./Certified.vue?vue&type=script&lang=js&"
import style0 from "./Certified.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports